import { EventEmitter, Injectable } from "@angular/core";
import { environment } from "src/environments/environment";

import { HttpClient } from "@angular/common/http";
import {
  CreatedDataFieldResponse,
  DataField,
  DataFieldFor,
  DeleteDataFieldResponse,
  GetCustomDataDashboardDataResponse,
  GetDataFieldResponse,
  GetDataFieldValueResponse,
  GetDynamicColumnsResponse,
} from "src/app/dashboard/main/accountant/setup-and-settings/client-contact-fields/models";
import { Subject } from "rxjs";

@Injectable({
  providedIn: "root",
})
export class CustomDataService {
  userInDrawer: Subject<any>;
  constructor(private http: HttpClient) {
    this.userInDrawer = new Subject();
  }

  addNewField(newField: DataField): Promise<CreatedDataFieldResponse> {
    const url = `${environment.apiUrl}/custom-data`;
    return this.http.post<CreatedDataFieldResponse>(url, newField).toPromise();
  }

  getAllDataFields(field_for: number): Promise<GetDataFieldResponse> {
    const url = `${environment.apiUrl}/custom-data?field_for=${field_for}`;
    return this.http.get<GetDataFieldResponse>(url).toPromise();
  }

  getAllDynamicColumns(
    columns_for: DataFieldFor,
  ): Promise<GetDynamicColumnsResponse> {
    const url = `${environment.apiUrl}/custom-data/importer?for=${columns_for}`;
    return this.http.get<GetDynamicColumnsResponse>(url).toPromise();
  }

  deleteField(fieldUuid: string): Promise<DeleteDataFieldResponse> {
    const url = `${environment.apiUrl}/custom-data?data_field=${fieldUuid}`;
    return this.http.delete<DeleteDataFieldResponse>(url).toPromise();
  }

  deleteContact(contact_uuid: string): Promise<any> {
    const url = `${environment.apiUrl}/custom-data/delete-contact?ctt=${contact_uuid}`;
    return this.http.delete(url).toPromise();
  }

  saveDataFieldValueChanges(
    data: { uuid: string; value: string }[],
  ): Promise<any> {
    const url = `${environment.apiUrl}/custom-data/data-field-value`;
    return this.http.put(url, { data_field_values: data }).toPromise();
  }

  updateDataFieldsOrder(data_fields: DataField[]): Promise<any> {
    const url = `${environment.apiUrl}/custom-data`;
    return this.http.put(url, { data_fields }).toPromise();
  }

  getCustomDataDashboardData(
    tags: any[],
    dashboardFor,
    start = null,
    rows = null,
    andOr = null,
  ): Promise<GetCustomDataDashboardDataResponse> {
    let tags_uuids = "";
    if (tags) {
      tags_uuids = tags.map((tag) => tag.uuid).join(",");
    }

    let params = `tags=${tags_uuids}&rows=${rows}&start=${start}&dashboard_for=${dashboardFor}`;
    if (andOr) {
      params = params + `&and_or=${andOr}`;
    }
    const url = `${environment.apiUrl}/custom-data/dashboard?${params}`;
    return this.http.get<GetCustomDataDashboardDataResponse>(url).toPromise();
  }

  editDataField(data_field): Promise<any> {
    const url = `${environment.apiUrl}/custom-data`;
    return this.http
      .patch<{ data_field: DataField }>(url, { data_field })
      .toPromise();
  }
}
